import { getGeneralLedgerData, getledgerbalance } from "./generalledger.js";

export function getIncomeAccounts(context) {  //20250213
    const {
        incomegroups,
        incomeaccounts,
        currencies,
        exchangerates,
    } = context;

    const generalledgerdata = getGeneralLedgerData(context);
    let filteredledgerdata = generalledgerdata
        .filter(data => data.accounttype == 'incomeaccounts')

    const data = [];

    incomegroups.forEach((group) => {
        let groupedaccounts = incomeaccounts.filter(account => account.groupid == group.id)

        data.push({
            id: group.id,
            name: group.name,
            tabletype: 'group'
        });

        groupedaccounts.forEach((account) => {
            let accountledgers = filteredledgerdata
                .filter(data => data.accountid == account.id)

            let currencysymbol = currencies.find(curr => curr.id == account.currencyid)?.symbol

            data.push({
                id: account.id,
                name: account.name,
                currencyid: account.currencyid,
                currencysymbol: currencysymbol,
                balance: getledgerbalance(accountledgers, exchangerates, account.currencyid, 'incomeaccounts'),
                tabletype: 'account',
                type: 'incomeaccounts'
            });
        });
    });

    let ungroupedaccounts = incomeaccounts.filter(account => account.groupid == '')
    ungroupedaccounts.forEach((account) => {
        let accountledgers = filteredledgerdata
            .filter(data => data.accountid == account.id)

        let currencysymbol = currencies.find(curr => curr.id == account.currencyid)?.symbol

        data.push({
            id: account.id,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencysymbol,
            balance: getledgerbalance(accountledgers, exchangerates, account.currencyid, 'incomeaccounts'),
            tabletype: 'account',
            type: 'incomeaccounts'
        });
    });

    return data;
}
